
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import FormulaireMaintenance from '@/components/maintenance/FormulaireMaintenance';
import { Maintenance } from '@/hooks/useMaintenances';
import { useTranslation } from 'react-i18next';

interface MaintenanceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  editingMaintenance: Maintenance | null;
  ajouterMaintenance: (maintenance: Omit<Maintenance, 'id' | 'user_id' | 'created_at' | 'updated_at'>) => Promise<any>;
  modifierMaintenance: (id: string, modifications: Partial<Maintenance>) => Promise<any>;
  onSaved: () => Promise<void>;
}

const MaintenanceDialog = ({
  isOpen,
  onClose,
  editingMaintenance,
  ajouterMaintenance,
  modifierMaintenance,
  onSaved,
}: MaintenanceDialogProps) => {
  const { t } = useTranslation('maintenance');
  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open) {
        onClose();
      }
    }}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto mx-4">
        <DialogHeader>
          <DialogTitle>
            {editingMaintenance ? t('dialog.editTitle') : t('dialog.addTitle')}
          </DialogTitle>
        </DialogHeader>
        
        <FormulaireMaintenance 
          onComplete={onClose}
          maintenanceToEdit={editingMaintenance || undefined}
          ajouterMaintenance={ajouterMaintenance}
          modifierMaintenance={modifierMaintenance}
          onSaved={onSaved}
        />
      </DialogContent>
    </Dialog>
  );
};

export default MaintenanceDialog;
